import React, { useState, useEffect } from "react";
import CustomNavbar from "../../components/CustomNavbar";
import { useSelector, useDispatch } from "react-redux";
import SidebarDashboard from "../../components/SidebarDashboard";
import { useHistory } from "react-router-dom";
import {
  Alert,
  Button,
  Card,
  Container,
  Breadcrumb,
  Spinner,
} from "react-bootstrap";
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";
import { getPositionHistory } from "../../redux/positionHistory/actions";
import { getPlazasVacantes } from "../../redux/seleccionContratacion/plazas_vacantes/actions";

const PositionHistory = (props) => {
  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const history = useHistory();

  const dispatch = useDispatch();
  const { loaderPositionHistory, positionHistory, positionHistoryFail } =
    useSelector((store) => store.positionHistory);
  const pages = Math.ceil(positionHistory ? positionHistory.count / limit : 0);

  const columns = [
    {
      Header: "Código de Empleado",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.empleado
            ? value.row.original.list_empleado[0].codigo
            : "Empleado no Asignado"}
        </div>
      ),
    },
    {
      Header: "Empleado",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.empleado
            ? value.row.original.list_empleado[0].nombre
            : "Empleado no Asignado"}
        </div>
      ),
    },
    {
      Header: "Fecha de Registro",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.fecha_creacion
            ? value.row.original.fecha_creacion
            : " "}
        </div>
      ),
    },
  ];
  // const filters = [{ id: "puesto", desc: "Puesto" }];

  const _getPositionHistory = (offs = offset, lim = limit) => {
    dispatch(
      getPositionHistory({
        offset: offs,
        limit: lim,

        filter: props.match.params.codigo,
        tipo_busqueda: "puesto",
      })
    );
  };

  useEffect(() => {
    dispatch(getPlazasVacantes());
    _getPositionHistory();
  }, [props.match.params.codigo]);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />

      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase"></h5>
          </div>
          <div className="d-flex flex-wrap justify-content-start align-items-center">
            <Button
              onClick={() =>
                history.push(
                  `/seleccion-contratacion/monitor-de-requerimientos/${props.match.params.type}/${props.match.params.id}/${props.match.params.nombrePuesto}/${props.match.params.codigo}/${props.match.params.rol}`
                )
              }
              variant="link"
              className="font-weight-bold mr-4 text-dark"
            >
              <i className="material-icons">arrow_back</i>
            </Button>
            <Breadcrumb className="pb-0">
              <Breadcrumb.Item
                title
                onClick={() =>
                  history.push(
                    `/seleccion-contratacion/${props.match.params.type}`
                  )
                }
              >
                Puestos
              </Breadcrumb.Item>
              <Breadcrumb.Item
                title
                // onClick={() => history.goBack()}
                onClick={() =>
                  history.push(
                    `/seleccion-contratacion/monitor-de-requerimientos/${props.match.params.type}/${props.match.params.id}/${props.match.params.nombrePuesto}/${props.match.params.codigo}/${props.match.params.rol}`
                  )
                }
              >
                Seguimiento de solicitudes
              </Breadcrumb.Item>
              <Breadcrumb.Item active title>
                Historial de puestos
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <div className="px-2">
            <hr />
          </div>
          <div className="d-flex justify-content-start mx-2">
            <h6>{props.match.params.nombrePuesto.replaceAll("-", "/")}</h6>
          </div>
          <div className="d-flex justify-content-around"></div>
          {!!positionHistoryFail && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {positionHistoryFail}
            </Alert>
          )}
          {!!positionHistoryFail && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {positionHistoryFail}
            </Alert>
          )}
          {loaderPositionHistory ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : positionHistory && positionHistory.count > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={positionHistory.data} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={positionHistory.count}
                pages={pages}
                pagFunc={_getPositionHistory}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              No hay registros anteriores para este puesto.
            </Alert>
          )}
        </Container>
      </div>
    </>
  );
};

export default PositionHistory;
